import type { MutableRefObject } from 'react';
import { Fragment, useEffect, useRef, useState } from 'react';

type TProps = {
  extraClasses?: string;
  fetcher: any;
  errorMessage?: string;
};

export const ActivationDigits = ({ fetcher, errorMessage, extraClasses = '' }: TProps) => {
  const [inFocus, setInFocus] = useState(false);
  const [activationDigits, setActivationDigits] = useState(''); // Track all digits as a string

  const refs: MutableRefObject<HTMLInputElement | null>[] = [
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
    useRef<HTMLInputElement | null>(null),
  ];

  const updateActivationDigits = () => {
    const activationDigits = refs.map((ref) => ref.current?.value || '').join('');
    setActivationDigits(activationDigits);
  };

  const handleInput = (code: string, targetName: string) => {
    if (!code) return;

    const index = Number(targetName);
    const target = refs[index - 1].current!;

    if (code.length === 1) {
      target.value = code;
      updateActivationDigits();
      refs[index]?.current?.focus();
      return;
    } else {
      const ref = refs[index - 1].current;
      if (ref) ref.value = '';

      if (code.length > 6) code = code.substring(0, 6);

      code.split('').forEach((c, i) => {
        const ref = refs[i]?.current;
        if (ref) ref.value = c;
      });

      updateActivationDigits();

      refs[code.length]?.current?.focus();
    }
  };

  useEffect(() => {
    if (activationDigits.length === 6) fetcher.submit(refs[5].current?.form);
  }, [activationDigits]);

  return (
    <div className={extraClasses}>
      <div className="d-flex justify-content-between">
        {[1, 2, 3, 4, 5, 6].map((digit) => (
          <Fragment key={digit}>
            <input
              autoComplete="off"
              type="number"
              className={`form-control activation-digit fo-display-1 text-center ${errorMessage ? 'is-invalid' : ''}`}
              id={'input-' + digit}
              placeholder={inFocus ? '' : '0'}
              data-rank={digit}
              onFocus={() => setInFocus(true)}
              onBlur={() => setInFocus(false)}
              onChange={(e) => handleInput(e.target.value, digit.toString())}
              onPaste={(e) => {
                e.preventDefault();
                handleInput(e.clipboardData.getData('text').replace(/\D/g, ''), digit.toString());
              }}
              name={digit.toString()}
              ref={refs[digit - 1]}
              onKeyDown={(e) => {
                if (e.key === 'Backspace' && digit - 1 > 0) {
                  refs[digit - 1].current!.value = '';
                  refs[digit - 2].current?.focus();
                }
                return;
              }}
            />
          </Fragment>
        ))}
      </div>
      <input
        type="hidden"
        name="activationDigits"
        value={activationDigits}
      />
      {!!errorMessage && <div className="text-2 -regular mt-1 color-error-600">{errorMessage}</div>}
    </div>
  );
};
